// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://quzhjtkaasdbpmagigsm.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF1emhqdGthYXNkYnBtYWdpZ3NtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQwMTUyMjMsImV4cCI6MjA1OTU5MTIyM30.2ZxDANQ1_Th-A049_Y2u23xyAb1s-VMJjlW6tnxwJfI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);